import { CountryCode, CountryOption, LanguageCode, LanguageOption } from "@/types";

export const getLocalizedPath = (
  pathname: string,
  countryOptions: CountryOption[],
  languageOptions?: LanguageOption[]
): { countryCode: CountryCode | null; languageCode: LanguageCode | null; pathname: string } => {
  let pathnameParts = pathname.replace("/~", "").split(/\/+/).slice(1);
  let languageOption: LanguageOption | null = null;

  const countryCodePath = pathnameParts[0];
  const countryCodePathUpper = countryCodePath?.toUpperCase();
  const countryOption = countryOptions.find((country) => country.iso2 === countryCodePathUpper);

  if (countryOption) {
    const languageCodePath = pathnameParts[1];
    const languageCodePathLower = languageCodePath?.toLowerCase();
    const languageOptionsOrCountryLanguageOptions = languageOptions
      ? languageOptions
      : countryOption.languages;
    languageOption =
      languageOptionsOrCountryLanguageOptions.find(
        (language) => language.iso2 === languageCodePathLower
      ) || null;

    pathnameParts = pathnameParts.slice(1);

    if (languageOption) {
      pathnameParts = pathnameParts.slice(1);
    }
  }

  return {
    countryCode: countryOption?.iso2 || null,
    languageCode: languageOption?.iso2 || null,
    pathname: `/${pathnameParts.join("/")}`
  };
};
